import React from 'react';
import { Link } from 'react-router-dom';
import { X, Loader2 } from 'lucide-react';

const RES_LABEL = {
  completado: { label: 'Completado', tone: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  parcial: { label: 'Parcial', tone: 'bg-amber-50 text-amber-700 border-amber-200' },
  sin_referencia: { label: 'Sin ref. válida', tone: 'bg-slate-100 text-slate-600 border-slate-200' },
  error: { label: 'Error', tone: 'bg-red-50 text-red-700 border-red-200' },
};

const Stat = ({ label, value, tone, testid }) => (
  <div className="rounded-lg border border-slate-200 p-3" data-testid={testid}>
    <p className="text-xs text-slate-500">{label}</p>
    <p className={`text-xl font-semibold ${tone}`}>{value}</p>
  </div>
);

// Progreso y resumen de la tarea SOLICITAR DATOS A CATASTRO.
export const CatastroBatchModal = ({ state, onClose }) => {
  if (!state) return null;
  const { total, done, running, resumen, detalle, rateLimited } = state;
  const revisar = detalle.filter(d => d.resultado !== 'completado');
  const pct = total ? Math.round((done / total) * 100) : 0;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="catastro-batch-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <h3 className="font-semibold text-slate-900">SOLICITAR DATOS A CATASTRO</h3>
          {!running && (
            <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="catastro-batch-close"><X className="w-5 h-5" /></button>
          )}
        </div>
        <div className="p-5 space-y-4 overflow-y-auto">
          <div>
            <div className="flex items-center justify-between text-sm text-slate-600 mb-1">
              <span className="flex items-center gap-2" data-testid="catastro-batch-progress-text">
                {running && <Loader2 className="w-4 h-4 animate-spin" />}
                {running ? 'Consultando Catastro…' : 'Tarea finalizada'} · {done}/{total}
              </span>
              <span>{pct}%</span>
            </div>
            <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
              <div className="h-full bg-blue-600 transition-[width] duration-300" style={{ width: `${pct}%` }} />
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <Stat label="Completados" value={resumen.completados} tone="text-emerald-600" testid="catastro-sum-completados" />
            <Stat label="Parciales" value={resumen.parciales} tone="text-amber-600" testid="catastro-sum-parciales" />
            <Stat label="Sin ref. válida" value={resumen.sin_referencia} tone="text-slate-600" testid="catastro-sum-sin-ref" />
            <Stat label="Con errores" value={resumen.errores} tone="text-red-600" testid="catastro-sum-errores" />
          </div>
          {rateLimited && (
            <p className="text-sm text-red-600" data-testid="catastro-batch-rate-limited">Catastro ha limitado las peticiones por hora. Los activos pendientes pueden reintentarse más tarde.</p>
          )}
          <p className="text-xs text-slate-500">Las coordenadas corresponden al centroide de la parcela catastral (WGS84), no a la entrada exacta del inmueble.</p>
          {revisar.length > 0 && (
            <div>
              <p className="text-sm font-medium text-slate-800 mb-2">Activos que requieren revisión ({revisar.length})</p>
              <ul className="divide-y divide-slate-100 border border-slate-200 rounded-lg" data-testid="catastro-batch-review-list">
                {revisar.map(d => (
                  <li key={d.id} className="px-3 py-2 text-sm flex items-start gap-3" data-testid={`catastro-review-${d.id}`}>
                    <span className={`shrink-0 text-[11px] px-2 py-0.5 rounded border ${RES_LABEL[d.resultado]?.tone}`}>{RES_LABEL[d.resultado]?.label}</span>
                    <div className="min-w-0">
                      <Link to={`/activos/${d.id}`} className="font-medium text-blue-700 hover:underline">
                        {d.codigo_npl || d.referencia_catastral || d.id}
                      </Link>
                      <span className="text-slate-500"> · {d.direccion || 'Sin dirección'}</span>
                      {d.mensaje && <p className="text-xs text-slate-500 break-words">{d.mensaje}</p>}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CatastroBatchModal;
